import ApiService from "@services/api.service";
import {Notify} from "quasar";

export const admissionRecord = {
  state:{
    record: null,
  },
  mutations:{
    setAdmissionRecord(state, record){
      state.record = record;
    }
  },
  actions:{
    async fetchAdmissionRecord(context, idDemandeInscription){
      try{
        const response = await ApiService.getRequest(`admission_records`, {demande_inscription: idDemandeInscription});
        context.commit("setAdmissionRecord", response.data["hydra:member"])
      }catch (error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
      }
    },
    async fetchEtudiantAdmissionRecord(context, idEtudiant){
      try{
        const response = await ApiService.getRequest(`admission_records`, {etudiant: idEtudiant});
        context.commit("setAdmissionRecord", response.data["hydra:member"])
      }catch (error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
      }
    },
    async addAdmissionRecord(context, data){
      try{
        const response = await ApiService.postRequest('admission_records', data,
          { headers: { 'Content-Type': 'application/json' } }
        );
        context.commit("setAdmissionRecord", response.data);
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout",
          color: 'red'
        })
      }
    },
    async updateAdmissionRecord(context, data){
      try{
        const response = await ApiService.patchRequest(`${data.url}`, data.datas);
        context.commit('setAdmissionRecord', response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    }
  },
  getters: {
    getAdmissionRecord(state){
      return state.record;
    }
  }
}
